let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2k0sZ")).then(() => parcelRequire('bGQ0c'));